const getters = {
  getOrganizations: state => state.organizations
}


export default getters